// ===== frontend/src/pages/FormPage.jsx (Updated with DynamicFormRenderer) =====
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PDFUploader from '../components/Upload/PDFUploader';
import RecommendedForms from '../components/Upload/RecommendedForms';
import DynamicFormRenderer from '../components/Form/DynamicFormRenderer';

const FormPage = () => {
  const { sessionId } = useParams();
  const [activeTab, setActiveTab] = useState('upload');

  // If we have a session, show the dynamic form
  if (sessionId) {
    return <DynamicFormRenderer sessionId={sessionId} />;
  }

  // Upload/Selection Mode
  return (
    <div style={{ maxWidth: '64rem', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
          PDF Form Upload
        </h1>
        <p style={{ color: '#6b7280', maxWidth: '32rem', margin: '0 auto' }}>
          Upload your PDF form or select a pre-built form to transform it 
          into a user-friendly web interface.
        </p>
      </div>

      {/* Tab Navigation */}
      <div style={{ marginBottom: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ backgroundColor: '#f3f4f6', padding: '0.25rem', borderRadius: '0.5rem' }}>
            <button
              onClick={() => setActiveTab('upload')}
              style={{
                padding: '0.5rem 1.5rem',
                borderRadius: '0.375rem',
                fontWeight: '500',
                fontSize: '0.875rem',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s',
                backgroundColor: activeTab === 'upload' ? 'white' : 'transparent',
                color: activeTab === 'upload' ? '#111827' : '#6b7280',
                boxShadow: activeTab === 'upload' ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'
              }}
            >
              Upload PDF
            </button>
            <button
              onClick={() => setActiveTab('recommended')}
              style={{
                padding: '0.5rem 1.5rem',
                borderRadius: '0.375rem',
                fontWeight: '500',
                fontSize: '0.875rem',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s',
                backgroundColor: activeTab === 'recommended' ? 'white' : 'transparent',
                color: activeTab === 'recommended' ? '#111827' : '#6b7280',
                boxShadow: activeTab === 'recommended' ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none'
              }}
            >
              Pre-built Forms
            </button>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '0.75rem',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb',
        padding: '2rem'
      }}>
        {activeTab === 'upload' && <PDFUploader />}
        {activeTab === 'recommended' && <RecommendedForms />}
      </div>

      {/* Features Info */}
      <div style={{ marginTop: '3rem', marginBottom: '3rem', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '3rem',
            height: '3rem',
            backgroundColor: '#dbeafe',
            borderRadius: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem auto'
          }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#2563eb' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <h3 style={{ fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>Fast</h3>
          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            Form creation in seconds, not hours
          </p>
        </div>
        
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '3rem',
            height: '3rem',
            backgroundColor: '#dbeafe',
            borderRadius: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem auto'
          }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#2563eb' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 style={{ fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>Accessible</h3>
          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            WCAG 2.1 compliant and accessible for all users
          </p>
        </div>
        
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '3rem',
            height: '3rem',
            backgroundColor: '#dbeafe',
            borderRadius: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem auto'
          }}>
            <svg style={{ width: '1.5rem', height: '1.5rem', color: '#2563eb' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <h3 style={{ fontWeight: '600', color: '#111827', marginBottom: '0.5rem' }}>Multilingual</h3>
          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            Automatic translation of German forms
          </p>
        </div>
      </div>
    </div>
  );
};

export default FormPage;